var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{staticClass:"login-error",attrs:{"transition":"slide-x-transition","data-qe-id":"login-error"},domProps:{"innerHTML":_vm._s(_vm.error)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }